export default __webpack_public_path__ + "static/media/cat.e6b0a563.png";